import { render, staticRenderFns } from "./OrdersTableDate.vue?vue&type=template&id=da055b36&"
import script from "./OrdersTableDate.vue?vue&type=script&lang=js&"
export * from "./OrdersTableDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports